

import { Component } from '@angular/core';




@Component({

    selector: 'payment-cmp',
    templateUrl: './paymentLko.component.html',
   
   
  })
export class PaymentLkoComponent {
  
}


// WEBPACK FOOTER //
// ./src/app/crm/kccLko/paymentLko/paymentLko.component.ts